import { Mainnet, Config, Sepolia } from '@usedapp/core'
// import { getDefaultProvider } from 'ethers'

export const dappConfig: Config = {
  readOnlyChainId: Mainnet.chainId,
  readOnlyUrls: {
    // [Mainnet.chainId]: getDefaultProvider('homestead'),
    [Mainnet.chainId]: 'https://eth.llamarpc.com',
    [Sepolia.chainId]: 'https://eth-sepolia.g.alchemy.com/v2/HguCJxpuejzEV-2It5XRgfDYj3uvwze7',
  },
  networks: [Mainnet, Sepolia],
}
